import '../styles.css';
import { formatTime, parseTime, pushDataLayerEvent } from './utils.js';
import { initializeTrimControls } from './trim-handler.js';
import messages from './loading_messages.json';

// Create worker instance
const videoWorker = new Worker(new URL('../../../ts/dist/workers/video-worker.js', import.meta.url), {
    type: 'module'
});

document.addEventListener('DOMContentLoaded', function () {

    function changeMessage() {
        let i = 0;
        setInterval(() => {
            // make it random message every 10 seconds
            let message = messages[Math.floor(Math.random() * messages.length)];
            document.getElementById('trimLoadingMessage').textContent = message;
            document.getElementById('audioLoadingMessage').textContent = message;
            document.getElementById('rotateLoadingMessage').textContent = message;
            i++;
            if (i >= messages.length) {
                i = 0;
            }
        }, 10000);
    }

    changeMessage();

    if (document.styleSheets.length > 0) {
        showContent();
    } else {
        // If CSS hasn't loaded yet, wait for it
        document.addEventListener('load', showContent, true);
    }
    // DOM Elements
    const elements = {
        uploadArea: document.getElementById('uploadArea'),
        videoInput: document.getElementById('videoInput'),
        videoPreview: document.getElementById('videoPreview'),
        video: document.getElementById('video'),
        fileName: document.getElementById('fileName'),
        rotationAngle: document.getElementById('rotationAngle'),
        downloadBtn: document.getElementById('downloadBtn'),
        errorMessage: document.getElementById('errorMessage'),
        tabButtons: document.querySelectorAll('.tab-button'),
        tabPanes: document.querySelectorAll('.tab-pane'),
        tabContainer: document.getElementById('tabContainer'),
        trimmingControls: document.getElementById('trimmingControls'),
        trimSpinnerContainer: document.getElementById('trimSpinnerContainer'),
        audioSpinnerContainer: document.getElementById('audioSpinnerContainer'),
        rotateSpinnerContainer: document.getElementById('rotateSpinnerContainer')
    };

    // State variables
    let currentMatrix = null;
    let uploadedFile = null;
    let originalVideo = null;

    initializeTrimControls();

    /**
     * Initialize event listeners
     */
    function initEventListeners() {
        // Upload events
        elements.uploadArea.addEventListener('click', () => elements.videoInput.click());
        elements.uploadArea.addEventListener('dragover', handleDragOver);
        elements.uploadArea.addEventListener('dragleave', handleDragLeave);
        elements.uploadArea.addEventListener('drop', handleDrop);
        elements.videoInput.addEventListener('change', handleInputChange);

        // Initialize tabs
        initializeTabs();
    }

    /**
     * Handle dragover event
     * @param {Event} e - Drag event
     */
    function handleDragOver(e) {
        e.preventDefault();
        elements.uploadArea.style.borderColor = '#3498db';
        elements.uploadArea.style.backgroundColor = 'rgba(52, 152, 219, 0.05)';
    }

    // When video is loaded, show the tab container
    function showTabsAfterVideoLoad() {
        const videoPreview = document.getElementById('videoPreview');
        if (!videoPreview.classList.contains('hidden')) {
            elements.tabContainer.classList.remove('hidden');

            // Move trim controls to the trim tab if they exist
            if (elements.trimmingControls) {
                // Hide the original container
                elements.trimmingControls.classList.add('hidden');
            }
        }
    }

    // Call this function when video is loaded
    // You'll need to add this call to your existing video load handler

    // Tab switching
    function initializeTabs() {
        // Get all tab buttons and panes
        const tabButtons = document.querySelectorAll('.tab-button');
        const tabPanes = document.querySelectorAll('.tab-pane');

        // Add click event listeners to tab buttons
        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                // Remove active class from all buttons and panes
                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabPanes.forEach(pane => pane.classList.remove('active'));

                // Add active class to current button and corresponding pane
                button.classList.add('active');
                const tabId = button.getAttribute('data-tab') + 'Tab';
                const tabPane = document.getElementById(tabId);
                if (tabPane) {
                    tabPane.classList.add('active');
                }

                // Update download button text based on selected tab
                updateDownloadButtonText(button.getAttribute('data-tab'));
            });
        });

        // Set initial active tab
        const initialTab = tabButtons[0];
        if (initialTab) {
            initialTab.classList.add('active');
            const initialTabId = initialTab.getAttribute('data-tab') + 'Tab';
            const initialTabPane = document.getElementById(initialTabId);
            if (initialTabPane) {
                initialTabPane.classList.add('active');
            }
            updateDownloadButtonText(initialTab.getAttribute('data-tab'));
        }
    }

    // Update download button text based on selected tab
    function updateDownloadButtonText(tabType) {
        switch (tabType) {
            case 'rotate':
                elements.downloadBtn.textContent = 'Download Rotated Video';
                break;
            case 'trim':
                elements.downloadBtn.textContent = 'Download Trimmed Video';
                break;
            case 'audio':
                elements.downloadBtn.textContent = 'Download Audio';
                break;
            default:
                elements.downloadBtn.textContent = 'Download';
        }
    }

    // Handle the download action based on active tab
    elements.downloadBtn.addEventListener('click', function () {
        const activeTab = document.querySelector('.tab-button.active').getAttribute('data-tab');

        switch (activeTab) {
            case 'rotate':
                pushDataLayerEvent("video_rotate", {});
                handleDownload();
                break;
            case 'trim':
                pushDataLayerEvent("video_trim", {});
                handleTrim();
                break;
            case 'audio':
                pushDataLayerEvent("video_extract_audio", {});
                handleAudioExtraction();
                break;
        }
    });



    function handleDownload() {
        if (!uploadedFile) return;

        if (!elements.rotationAngle.value) {
            alert('Please select a rotation angle');
            return;
        }
        videoWorker.postMessage({
            type: 'rotate',
            data: {
                file: uploadedFile,
                rotationSteps: elements.rotationAngle.value
            }
        });
        videoWorker.onmessage = (e) => {
            if (e.data.type === 'success') {
                downloadModifiedFile(uploadedFile, e.data.data.offset, e.data.data.buffer);
            }else {
                console.error(e.data.error);
                pushDataLayerEvent("video_failure", {
                    action: "rotate_video",
                    video_name: uploadedFile.name,
                    video_size: uploadedFile.size,
                    error: e.data.error
                });
                showErrorMessage('Error processing video. Please try again.');
            }
        };

        const rotationSteps = elements.rotationAngle.value;
      
        elements.rotateSpinnerContainer.style.display = 'none';
    }

    function handleTrim() {
        elements.trimSpinnerContainer.style.display = 'flex';

        // Get trim times
        const startTimeInput = document.getElementById('startTime');
        const endTimeInput = document.getElementById('endTime');
        const startTimeUs = BigInt(Math.round(parseTime(startTimeInput.value) * 1_000_000));
        const endTimeUs = BigInt(Math.round(parseTime(endTimeInput.value) * 1_000_000));

        if (!uploadedFile) return;

        // Create a copy of the buffer for transfer
        videoWorker.postMessage({
            type: 'trim',
            data: {
                file: uploadedFile,
                startTime: startTimeUs,
                endTime: endTimeUs
            }
        });

        videoWorker.onmessage = (e) => {
            if (e.data.type === 'success') {
                const blob = new Blob([e.data.data], { type: 'video/mp4' });
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = 'trimmed_video.mp4';
                link.click();
                URL.revokeObjectURL(url);
            } else {
                console.error(e.data.error);
                pushDataLayerEvent("video_failure", {
                    action: "trim_extraction",
                    video_name: uploadedFile.name,
                    video_size: uploadedFile.size,
                    error: e.data.error
                });
                showErrorMessage('Error processing video. Please try again.');
            }
            elements.trimSpinnerContainer.style.display = 'none';
        };
    }

    function handleAudioExtraction() {
        elements.audioSpinnerContainer.style.display = 'flex';

        if (!uploadedFile) return;


        videoWorker.postMessage({
            type: 'audio',
            data: {
                file: uploadedFile,
            }
        });

        videoWorker.onmessage = (e) => {
            if (e.data.type === 'success') {
                const blob = new Blob([e.data.data], { type: 'audio/mp4' });
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = 'extracted_audio.m4a';
                link.click();
                URL.revokeObjectURL(url);
            } else {
                console.error(e.data.error);
                pushDataLayerEvent("video_failure", {
                    action: "audio_extraction",
                    video_name: uploadedFile.name,
                    video_size: uploadedFile.size,
                    error: e.data.error
                });
                showErrorMessage('Error processing audio. Please try again.');
            }
            elements.audioSpinnerContainer.style.display = 'none';
        };
    }

    function showErrorMessage(message) {
        elements.errorMessage.textContent = message;
        elements.errorMessage.classList.remove('hidden');
        setTimeout(() => {
            elements.errorMessage.textContent = '';
            elements.errorMessage.classList.add('hidden');
        }, 5000);
    }

    /**
     * Handle dragleave event
     */
    function handleDragLeave() {
        elements.uploadArea.style.borderColor = '#ddd';
        elements.uploadArea.style.backgroundColor = 'transparent';
    }

    /**
     * Handle drop event
     * @param {Event} e - Drop event
     */
    function handleDrop(e) {
        e.preventDefault();
        elements.uploadArea.style.borderColor = '#ddd';
        elements.uploadArea.style.backgroundColor = 'transparent';

        const files = e.dataTransfer.files;
        if (files.length > 0 && files[0].type.startsWith('video/')) {
            handleFileUpload(files[0]);
        }
    }

    /**
     * Handle input change event
     */
    function handleInputChange() {
        if (elements.videoInput.files.length > 0) {
            handleFileUpload(elements.videoInput.files[0]);
        }
    }
    async function downloadModifiedFile(file, offset, replacement) {
        elements.rotateSpinnerContainer.style.display = 'flex';
        if (replacement.length !== 36) {
            throw new Error("Replacement must be exactly 36 bytes");
        }

        const reader = file.stream().getReader();
        let bytesRead = 0;
        let replaced = false;

        const transformer = new TransformStream({
            async transform(chunk, controller) {
                const chunkOffset = bytesRead;
                bytesRead += chunk.length;

                const chunkStart = chunkOffset;
                const chunkEnd = chunkOffset + chunk.length;

                const replaceStart = offset;
                const replaceEnd = offset + 36;

                const result = new Uint8Array(chunk.length);
                result.set(chunk);

                // Check if replacement overlaps this chunk
                if (!replaced && replaceEnd > chunkStart && replaceStart < chunkEnd) {
                    const withinChunkStart = Math.max(replaceStart - chunkOffset, 0);
                    const withinChunkEnd = Math.min(replaceEnd - chunkOffset, chunk.length);

                    const replacementStart = Math.max(chunkOffset - replaceStart, 0);
                    const replacementSlice = replacement.slice(
                        replacementStart,
                        replacementStart + (withinChunkEnd - withinChunkStart)
                    );

                    result.set(replacementSlice, withinChunkStart);

                    if (bytesRead >= replaceEnd) {
                        replaced = true;
                    }
                }

                controller.enqueue(result);
            }
        });

        const modifiedStream = file.stream().pipeThrough(transformer);
        const response = new Response(modifiedStream);
        const blob = await response.blob();

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = file.name.replace(/(\.[^.]+)?$/, "_modified$1");
        a.click();
        URL.revokeObjectURL(url);
        elements.rotateSpinnerContainer.style.display = 'none';
    }


    /**
     * Handle file upload
     * @param {File} file - Uploaded file
     */
    function handleFileUpload(file) {
        elements.errorMessage.classList.add('hidden');
        uploadedFile = file;

        // Set up video preview
        const videoURL = URL.createObjectURL(file);
        elements.video.src = videoURL;
        elements.fileName.textContent = file.name;

        // Set up video metadata
        elements.video.onloadedmetadata = function () {
            const videoDuration = Math.round(elements.video.duration);
            document.getElementById('endTime').value = formatTime(videoDuration);
            // Track video upload analytics
            pushDataLayerEvent("video_upload", {
                video_name: file.name,
                video_size: file.size,
                video_duration: videoDuration
            });
        };

        elements.downloadBtn.disabled = false;


        // Show video preview and trimming controls
        elements.videoPreview.classList.remove('hidden');

        // Show the tabs
        elements.tabContainer.classList.remove('hidden');

        // Reset matrix
        currentMatrix = null;
    }

    // Initialize
    initEventListeners();
});

function showContent() {
    const content = document.querySelector('.no-fouc');
    if (content) {
        content.style.display = 'block';
    }
} 